<template>
  <header
    class="gap-6 items-center mx-auto max-w-screen-xl flex flex-col text-center justify-center py-8 px-4 lg:py-12 lg:px-6"
  >
    <div class="font-light text-gray-500 sm:text-lg">
      <h2 class="mb-4 text-3xl tracking-tight font-semibold text-gray-900">
        Unsere Galerie - Rückblicke in die Vergangenheit
      </h2>
      <p class="mb-4">
        Tauchen Sie ein in die magische Welt des Circus St.Ottilien - Erleben
        Sie faszinierende Einblicke in die Manege der vergangenen Jahre und
        lassen Sie sich verzaubern von atemberaubenden Momenten, die einen
        Vorgeschmack auf das geben, was Sie im Jahr 2025 bei unserer
        spektakulären Show erwarten wird.
      </p>
    </div>
  </header>
</template>
